import { render, staticRenderFns } from "./MarketplaceCards.vue?vue&type=template&id=4f1f8f03&scoped=true&"
import script from "./MarketplaceCards.vue?vue&type=script&lang=js&"
export * from "./MarketplaceCards.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceCards.vue?vue&type=style&index=0&id=4f1f8f03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1f8f03",
  null
  
)

export default component.exports